const translation = {
  title: 'Badać',
  sidebar: {
    discovery: 'Descoberta',
    chat: 'Chat',
    workspace: 'Espaço de Trabalho',
    action: {
      pin: 'Fixar',
      unpin: 'Desafixar',
      rename: 'Renomear',
      delete: 'Excluir',
    },
    delete: {
      title: 'Excluir aplicativo',
      content: 'Tem certeza de que deseja excluir este aplicativo?',
    },
  },
  apps: {
    title: 'Explorar Aplicações por Dify',
    description: 'Use esses aplicativos modelo instantaneamente ou personalize seus próprios aplicativos com base nos modelos.',
    allCategories: 'Recomendado',
  },
  appCard: {
    addToWorkspace: 'Adicionar ao Espaço de Trabalho',
    customize: 'Personalizar',
  },
  appCustomize: {
    title: 'Criar aplicativo a partir de {{name}}',
    subTitle: 'Ícone e nome do aplicativo',
    nameRequired: 'O nome do aplicativo é obrigatório',
  },
  category: {
    Assistant: 'Assistente',
    Writing: 'Escrita',
    Translate: 'Traduzir',
    Programming: 'Programação',
    HR: 'RH',
    Workflow: 'Fluxo de trabalho',
    Agent: 'Agente',
    Entertainment: 'Entretenimento',
  },
}

export default translation
